import Grid from "@mui/material/Grid2";
import React from "react";
import BackToWelcomPageButton from "../../atoms/buttons/backToWelcomPageButton/backToWelcomPageButton";
import MinimizeChatBotButton from "../../atoms/buttons/minimizeChatBotButton/minimizeChatBotButton";
import { AppContext } from "../../../store/genesys.context";
import { Avatar, Box, Typography } from "@mui/material";
import AvatarMia from "../../../assets/images/mia-kreis.png";
import NavbarBrand from "../../atoms/icons/navbarBrand.styled";
import NavbarWrapper from "../../atoms/wrapper/navbarWrapper.styled";
import IMessage from "../../../interface/IMessage";
import IChatbot from "../../../interface/iChatbot";

const NavbarContainer = (): React.JSX.Element => {
  const {
    rateChat,
    openChat,
    acceptDataProtectionNotice,
    chatbot,
  }: {
    rateChat: boolean;
    openChat: boolean;
    acceptDataProtectionNotice: boolean;
    chatbot: IChatbot;
  } = React.useContext(AppContext);

  const lastAgentMessage: IMessage | undefined = React.useMemo(
    () => chatbot.messages.slice().reverse().find((msg) => msg.sender === "agent"),
    [chatbot.messages],
  );

  // genesys has only an emty string for the avatar (maybe this came later)
  // so we have to use the agent name to get the avatar
  // if the agent name is not set, we use the default avatar
  const agentAvatar: string =
    lastAgentMessage &&
    lastAgentMessage?.agent.name &&
    lastAgentMessage?.agent.name.trim() !== ""
      ? lastAgentMessage.agent.avatar
      : AvatarMia;
  const agentName = lastAgentMessage?.agent.name?.trim()
    ? lastAgentMessage.agent.name.trim()
    : "Mia";

  const getNavBarTitle = (): React.JSX.Element => {
    if (openChat && !rateChat && acceptDataProtectionNotice)
      return (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "left",
            width: "100%",
          }}
        >
          <Avatar alt="agent-avatar" src={agentAvatar} />

          <Typography
            variant="body1"
            sx={{
              fontWeight: "bold",
              marginLeft: "1rem",
            }}
          >
            {agentName}
          </Typography>
        </Box>
      );

    if (rateChat)
      return (
        <Typography
          variant="body1"
          sx={{
            fontWeight: "bold",
            width: "100%",
            textAlign: "center",
          }}
        >
          Unterhaltung bewerten
        </Typography>
      );

    return <></>;
  };

  return (
    <NavbarWrapper>
      <Grid
        container
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Grid
          size={{ xs: 2 }}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <BackToWelcomPageButton />
        </Grid>

        <Grid size={{ xs: 8 }}>
          <NavbarBrand>{getNavBarTitle()}</NavbarBrand>
        </Grid>

        <Grid
          size={{ xs: 2 }}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <MinimizeChatBotButton />
        </Grid>
      </Grid>
    </NavbarWrapper>
  );
};

export default NavbarContainer;
